import React, { useState } from 'react';
import uniqueId from 'lodash/uniqueId';

import SearchIcon from '~/components/AiChat/icons/SearchIcon';
import TextField from '~/components/core/Molecules/Fields/TextField';
import cn from '~/Utils/cn';

interface ChatSearchFieldProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

const ChatSearchField: React.FC<ChatSearchFieldProps> = ({
  value,
  onChange,
  placeholder = 'Search Chat',
  className,
}) => {
  const [id] = useState(() => uniqueId('chat-search-'));

  return (
    <TextField
      value={value}
      onChange={onChange}
      id={id}
      className={cn('h-40 justify-center rounded-full bg-white bg-opacity-80 pl-16 pr-12 pt-2', className)}
      fullWidth
      InputProps={{
        disableUnderline: true,
        placeholder,
        endAdornment: <SearchIcon size={16} className="text-blue-600" />,
      }}
    />
  );
};

export default ChatSearchField;
